import { render, staticRenderFns } from "./register-upgrade-ktba.vue?vue&type=template&id=c248a982&scoped=true"
import script from "./register-upgrade-ktba.vue?vue&type=script&lang=ts"
export * from "./register-upgrade-ktba.vue?vue&type=script&lang=ts"
import style0 from "./register-upgrade-ktba.vue?vue&type=style&index=0&id=c248a982&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c248a982",
  null
  
)

/* vuetify-loader */
import installComponents from "!../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VMain } from 'vuetify/lib/components/VMain';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VApp,VMain,VOverlay,VProgressCircular,VSnackbar})


/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c248a982')) {
      api.createRecord('c248a982', component.options)
    } else {
      api.reload('c248a982', component.options)
    }
    module.hot.accept("./register-upgrade-ktba.vue?vue&type=template&id=c248a982&scoped=true", function () {
      api.rerender('c248a982', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "layouts/register-upgrade-ktba.vue"
export default component.exports